import { LocMarkupBase } from './loc_markup_base.js';

class LocMarkupEdit extends LocMarkupBase {
  static get selectors() {
    const PickTrackContainer = '.loc-edit-track';
    const RelContainer = '.map-panel-edit-rels';
    const RelSets = `${RelContainer} spreadsheet-control`;
    const Rels = `${RelContainer} pick-loc-control`;
    const StateCheckboxContainer = '.map-panel-edit-state';
    return Object.assign({}, super.selectors, {
      AttributeContainer: '.locview-edit-attributes',
      CancelButton: '.dialog-cancel',
      DeleteOrReportButton: '.delete-or-report-button',
      DescriptionTextarea: 'textarea',
      FieldsSpreadsheet: '.loc-edit-fields-spreadsheet',
      Form: '.locedit-form',
      LatInput: '.loc-edit-lat',
      LngInput: '.loc-edit-lng',
      MobileBackButton: '.locview-backbutton',
      MobileSaveButton: '.locview-savebutton',
      NameInput: '.loc-edit-name',
      PicList: 'picupload-list.locedit-panel-pics',
      PickTrack: `${PickTrackContainer} > pick-track-control`,
      PickTrackContainer,
      RelContainer,
      RelLabels: `${RelContainer} > label`,
      RelSets,
      Rels,
      RelByTypeAndIndex: (type, index) =>
        `${RelSets}[type=${type}] > pick-loc-control:nth-child(${index + 2})`,
      RelOrRelSetByType: type => `${RelContainer} > [type=${type}]`,
      Type: '.loc-edit-type',
      SaveButton: '.dialog-accept',
      SaveSubmitButton: 'button[type=submit]',
      StateCheckbox: `${StateCheckboxContainer} > .loc-edit-state-checkbox`,
      StateCheckboxContainer,
    });
  }

  get editMarkup() {
    let fieldsMakrup = this.allFieldNames
      .sort()
      .reduce((a, v) => `${a}<option>${v}</option>`, '');

    let acceptButtonName = this.loc.id ? 'Update' : 'Add';

    let deleteOrReportHidden = this.loc.id ? '' : 'hidden';
    let deleteOrReportName = !parseInt(this.loc.readonly) ? 'Delete' : 'Report';
    let deleteOrReportButtonMarkup = `
      <span class='dialog-button delete-or-report-button'
            ${deleteOrReportHidden}
            tabindex='0'>${deleteOrReportName}</span>
    `;

    return `
      ${this.coverMarkup}
      <form class='locedit-form'>
        <picupload-list class='locedit-panel-pics'></picupload-list>
        <input class='loc-edit-name map-panel-input-control'
               value='${this.loc.name}'
               placeholder='Location name' required>
        <loctype-control class='loc-edit-type'></loctype-control>
        <div class='locedit-coordinates'>
          <label>Latitude:
            <input class='loc-edit-lat'
                   value='${this.loc.lat.toFixed(7)}'
                   required type='number'
                   step='0.0000001'></label>
          <label>Longitude:
            <input class='loc-edit-lng'
                   value='${this.loc.lng.toFixed(7)}'
                   required type='number'
                   step='0.0000001''></label>
        </div>
        <textarea class='map-panel-input-control'
                  placeholder='Location description'
                  rows='12'>${this.loc.description}</textarea>
        <div class='map-panel-edit-rels'></div>
        <div class='loc-edit-track' hidden>
          <label>Track:</label>
          <pick-track-control></pick-track-control>
        </div>
        <div class='locview-edit-attributes map-panel-control'></div>
        <div class='map-panel-edit-fields map-panel-control'>
          <span class='map-panel-edit-fields-label'>Links and info (leave fields blank to remove):</span>
          <datalist id='map-panel-fields-datalist'>
            ${fieldsMakrup}
          </datalist>
          <spreadsheet-control colcount='2' class='loc-edit-fields-spreadsheet'>
            <template>
              <input list='map-panel-fields-datalist'
                     class='map-panel-input-control spreadsheet-cell'
                     placeholder='Label'>
              <input class='map-panel-input-control spreadsheet-cell'
                     placeholder='URL or value'>
            </template>
          </spreadsheet-control>
        </div>
        <label class='map-panel-edit-state'>
          <input class='loc-edit-state-checkbox' type='checkbox'>Keep private
        </label>
        <div class='map-panel-edit-link-list dialog-buttons'>
          ${deleteOrReportButtonMarkup}
          <span class='dialog-button dialog-accept' tabindex='0'>${acceptButtonName}</span>
          <span class='dialog-button dialog-cancel' tabindex='0'>Cancel</span>
        </div>
        <button type='submit' hidden></submit>
      </form>
    `;
  }

  get coverButtonsMarkup() {
    return `
      <span class='locview-backbutton locview-round-button'
            title='Close the panel'></span>
      <span class='locview-savebutton locview-round-button'
            title='Save location'></span>
    `;
  }
}

export { LocMarkupEdit };
